import React, { useState } from 'react';
import { Button, Space, Typography } from 'antd';
import PCLoginPage from './PCLoginPage/PCLoginPage';
import H5LoginPage from './H5LoginPage/H5LoginPage';

const { Title } = Typography;

const DemoPage = () => {
  const [viewMode, setViewMode] = useState('auto'); // 'auto', 'pc', 'h5'

  const renderDemo = () => {
    switch (viewMode) {
      case 'pc':
        return <PCLoginPage />;
      case 'h5':
        return <H5LoginPage />;
      default:
        return (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <Title level={3}>Trip.com SSO 登录页面 - 组件演示</Title>
            <Space size="middle" style={{ marginBottom: '20px' }}>
              <Button type="primary" onClick={() => setViewMode('pc')}>
                PC端预览
              </Button>
              <Button type="primary" onClick={() => setViewMode('h5')}>
                H5端预览
              </Button>
            </Space>
            <div style={{ color: '#666', marginBottom: '20px' }}>
              选择上方按钮预览不同设备的登录界面
            </div>
          </div>
        );
    }
  };

  return (
    <div style={{ height: '100vh', position: 'relative' }}>
      {viewMode !== 'auto' && (
        <div style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          zIndex: 1000,
          background: 'rgba(255, 255, 255, 0.9)',
          padding: '10px',
          borderRadius: '5px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <Space>
            <Button size="small" onClick={() => setViewMode('auto')}>
              返回选择
            </Button>
            <Button size="small" type={viewMode === 'pc' ? 'primary' : 'default'} onClick={() => setViewMode('pc')}>
              PC端
            </Button>
            <Button size="small" type={viewMode === 'h5' ? 'primary' : 'default'} onClick={() => setViewMode('h5')}>
              H5端
            </Button>
          </Space>
        </div>
      )}
      {renderDemo()}
    </div>
  );
};

export default DemoPage; 